import { Navigate, useLocation } from 'react-router-dom';

/** Legacy /book-consultation links land on Contact; query (reason, summary) preserved. */
export function BookConsultationToContactRedirect() {
  const location = useLocation();
  const sp = new URLSearchParams(location.search);
  const qs = sp.toString();
  return <Navigate to={qs ? `/contact?${qs}#book-support` : '/contact#book-support'} replace />;
}
